module.exports = __webpack_public_path__ + "img/agent-kb.89e2e472.png";